import { Runtime } from '@/core/enums/runtime.enum'

export const PACKAGE_MANAGER_MAP: Record<Runtime, string> = {
  [Runtime.Nodejs]: 'npm',
  [Runtime.Netcore]: 'nuget',
  [Runtime.Jvm]: 'maven',
  [Runtime.Python]: 'pypi',
  [Runtime.Ruby]: 'ruby',
  [Runtime.Php]: 'packagist',
} as const

export type RuntimeName = Runtime
export type PackageManager = (typeof PACKAGE_MANAGER_MAP)[Runtime]
